export default "__VITE_PUBLIC_ASSET__d56a9317__"